// extracted by mini-css-extract-plugin
export default {"classNameCell":"ClassNameCell_classNameCell__Xunyq"};